import UtilSP from 'SATPROF_UTILS/UtilSP';
import Complex from 'SATPROF_UTILS/Complex';
import Waveform1 from 'SATPROF_UTILS/Waveform1';
import Waveform2 from 'SATPROF_UTILS/Waveform2';
import SigProc from 'SATPROF_UTILS/SigProc';

export default class Distortion {
	/*
	 limiter( caSin, PlimitdBm, Z0 )   // Applies hard power limit to caS waveform.  Returns caS
	 applyHPAModel3ToSpectrum(...)  // Applies RB HPA3 distortion model to caS
	 HPA_model3(...)  // Calculation engine for HPA3 model
	
	*/

    public constructor(){
    
    }
	/*
    public static limiter(caSin:Array<Complex>, PlimitdBm:number, Z0:number ){
  		// caSin must be a complex array representing the complex spectrum of a signal
		
		let N = caSin.length;
		let caIQ:Array<Complex> = new Array(N);
		let caSout:Array<Complex> = new Array(N);
		
		caIQ = SigProc.ifft( caSin );
		
		let threshW = Math.pow(10, (PlimitdBm-30)/10);
		let threshV = Math.sqrt(  threshW * Z0 );
		//trace("Z0 = "+Z0+", Plim = "+PlimitdBm+", threshW = "+threshW+", threshV = "+threshV);
		
		for (let i = 0; i<N; i++){
			let mag = Math.min( threshV, Complex.abs( caIQ[i] ) );
			let ang = Complex.phase( caIQ[i] );
			caIQ[i] = Complex. polar(mag, ang);
			//trace(mag+", "+ang);
		}
		caSout = SigProc.fft( caIQ );
		return caSout;  
    }
	*/
	/*
 	public static applyHPAModel3ToSpectrum(caSin, ss_gain, Psat, softness, IBO_corner, gain_bump_ht, gain_bump_width, 
            IBO_of_gain_bump, gain_foldover, phase_max, IBO_of_phase_peak, phase_width, phase_shape) {
		/* caSin must be a complex array representing the complex spectrum of a signal
		A typical SSPA:
		ss_gain = 36.5;
		Psat = 40.3;
		softness = 0.8;
		IBO_corner = 0;
		gain_bump_ht = 0.5;
		gain_bump_width = 3;
		IBO_of_gain_bump = -4;
		gain_foldover = 0;
		phase_max = 33;
		IBO_of_phase_peak = 8.1;
		phase_width = 10;
		phase_shape = 2;

		*/
		/*
		let N = caSin.length;
		let caIQ:Array = new Array(N);
		let caSout:Array = new Array(N);
		
		caIQ = SigProc.ifft( caSin );
		
		let PinWAvg = 0;
		let PoutWAvg = 0;
		let PindBmAvg;
		let PoutdBmAvg;
		
		for (let i = 0; i<N; i++){
			let Vin = Complex.abs( caIQ[i] );
			let PinW = Vin * Vin / 50;
			PinWAvg += PinW;
			let PindBm = UtilSP.W2dBm( PinW );
			let PoutdBm = HPA_model3(PindBm, "Pout", ss_gain, Psat, softness, IBO_corner, gain_bump_ht, gain_bump_width, 
            			IBO_of_gain_bump, gain_foldover, phase_max, IBO_of_phase_peak, phase_width, phase_shape);
			let PoutW = UtilSP.dBm2W( PoutdBm );
			PoutWAvg += PoutW;
			let mag:number = Math.sqrt( PoutW*50 );
			
			let phaseShift = HPA_model3(PindBm, "phase", ss_gain, Psat, softness, IBO_corner, gain_bump_ht, gain_bump_width, 
            			IBO_of_gain_bump, gain_foldover, phase_max, IBO_of_phase_peak, phase_width, phase_shape);
			
			let ang:number = Complex.phase( caIQ[i] ) + phaseShift;
			caIQ[i] = Complex.polar(mag, ang);
			//trace(mag+", "+ang);
			//trace("In Distortion, i = "+i+", PindBm = "+PindBm+", PoutdBm = "+PoutdBm+", phaseShift = "+phaseShift+", PoutW = "+PoutW+", mag = "+mag+", ang = "+ang );
		}
		caSout = SigProc.fft( caIQ );
		PindBmAvg = UtilSP.W2dBm(PinWAvg);
		PoutdBmAvg = UtilSP.W2dBm(PoutWAvg);
		//trace("Pin avg = "+PindBmAvg+" dBm; Pout avg = "+PoutdBmAvg+" dBm.");
		return caSout;
		
	}
	*/
	public static ThirdOrderSaturating(Pin, ssg_dB, P1dBout){
		let P1dBin:number, AinP1:number, k1:number, k3:number, Ain:number, A1:number, PsatIn:number, PoutX:number, PsatOut:number;
    
		P1dBin = P1dBout - ssg_dB + 1;
		PsatIn = P1dBin + 4.8;
		PsatOut = P1dBout + 2.33;
        AinP1 = UtilSP.dB2Vratio(P1dBin);
        k1 = UtilSP.dB2Vratio(ssg_dB);
        k3 = k1 * (0.891 - 1) * (4 / 3) / (AinP1*AinP1);
    
        Ain = UtilSP.dB2Vratio(Pin);
        A1 = k1 * Ain + (3 * k3 / 4) * (Ain*Ain*Ain);
        if (A1 > 0) {
            PoutX = UtilSP.Vratio2dB(A1);
        } else {
            PoutX = -999;
        }
        if (Pin < PsatIn) {
            return PoutX;
        } else {
            return PsatOut;
        }
	}
	public static HPA_model3_typical_TWTA(Pin:number, ss_gain:number, Psat:number, resultRequest:string){

		let _HPA3_softness:number = 1.5;
		let _HPA3_IBO_corner_dB:number = 0;
		let _HPA3_gainBumpHeight_dB:number = 0;
		let _HPA3_gainBumpWidth_dB:number = 3;
		let _HPA3_IBOgainBump_dB:number = -4;
		let _HPA3_gainFoldover:number = 1.1; 
		let _HPA3_phaseMax_deg:number = 33;
		let _HPA3_IBOphasePeak_dB:number = 8.1;
		let _HPA3_phaseWidth_dB:number = 10;
		let _HPA3_phaseShape:number = 1.7;

		return this. HPA_model3(Pin, resultRequest, ss_gain, Psat, _HPA3_softness, _HPA3_IBO_corner_dB,
		 _HPA3_gainBumpHeight_dB, _HPA3_gainBumpWidth_dB, _HPA3_IBOgainBump_dB, _HPA3_gainFoldover, 
		 _HPA3_phaseMax_deg, _HPA3_IBOphasePeak_dB, _HPA3_phaseWidth_dB, _HPA3_phaseShape);
	
	}
	public static HPA_model3(Pin:number, resultRequest:string, ss_gain:number, Psat:number, softness:number, IBO_corner:number,
		 gain_bump_ht:number, gain_bump_width:number, IBO_of_gain_bump:number, gain_foldover:number, 
		 phase_max:number, IBO_of_phase_peak:number, phase_width:number, phase_shape:number) {
		/*
		'Revised RLB 10/10/03

		' Empirical transfer curve fit.
		'
		' Returns amplitude response (gain, compression, or Pout) or phase shift vs input power of an
		' amplifier with the provided parameters:
		' Pin = Input power in dBm or dBW (same units as Psat)
		' result = "compr", "gain", "Pout", or "phase"
		' ss_gain = small-signal gain in dB
		' Psat = asymptotic output power in saturation (not including the effect of the gain bump or rollover)
		' softness = softness of the compression curve.  0 = ideal limiter, 0.8 = typical SSPA, 1.5 = typical TWT.
		' IBO_corner = IBO (from sat) of the compression corner (-ve). Typically 0.
		' gain_bump_ht = height in dB of extra Gaussian bump. 0 = typical TWT. 0.5 = SSPA typical.
		' gain_bump_width = width of gain bump (1 sigma) on the input scale. 3 = typical SSPA. (use any value for TWT)
		' IBO_of_gain_bump = IBO (from sat) of the center of bump. -4 = SSPA
		' gain_foldover = degree of gain reduction after the saturation point 0= typ SSPA, 1.1=typ TWTA
		' phase_max = phase at the top of the peak.  33 typ SSPA.
		' IBO_of_phase_peak = IBO (from sat) at the phase max. 8.1 typ.
		' phase_width = width of the phase hump (1-sigma) 10 - SSPA typ
		' phase_shape = "squareness" factor.  2 = typ SSPA (Gaussian), 1.7 = typ TWTA
		
		
		*/
		if (Pin == Number.NEGATIVE_INFINITY){
			switch (resultRequest){
				case "compr":
					return 0;
					break;
				case "Pout":
					return (Pin + ss_gain);
					break;
				case "gain":
					return (ss_gain);
					break;
				case "phase":
					return 0;
					break;
				default:
					console.log( "Error in function hpa_model3: invalid parameter requested: " + resultRequest );
					return 0;
					break;
			}
		}
		
		let iboc:number = Pin + ss_gain - Psat; // IBO from the corner of the rotated hyperbolic compression curve.
		let iboc_sat:number = -IBO_corner; // IBO of saturation point w.r.t. corner (+ve)
		let ibos:number = iboc - iboc_sat; // IBO from saturation point

		let e:number = 2.71;
		let compression:number;
		let phase_shift:number;

		if ( (resultRequest == "compr") || (resultRequest == "gain") || (resultRequest == "Pout") ){
			/* 	
			Compute the amplitude response.
			Rotated hyberbolic curve.  Fits compression vs IBO.
    		For IBO << 0, returns 0.
    '		For IBO >>0, returns -IBO.  For ssg = 0, Psat = 0.
    		For IBO = 0, returns ~0 if softness = 0; returns more negative as softness increases.
			*/
    		let A:number = softness;
    		let R:number = 0.392699082; // 22.5 degrees
    		let a_b:number = Math.tan(R);
    		let cos_r:number = Math.cos(R);
    		let sin_r:number = Math.sin(R);
    		let k:number = cos_r*cos_r - (a_b * a_b) * sin_r  * sin_r;

    		let xp:number = iboc;
    		let x:number = (xp * cos_r + sin_r * Math.sqrt(xp*xp * a_b*a_b + (A*A) * k)) / k;
    		let y:number = -1 * Math.sqrt(A*A + x*x * a_b*a_b);
    		let yp:number = y * cos_r - x * sin_r; // Result of rotated hyperbolic curve.

    		// Add the extra Gaussian bump:
    		let bump:number = gain_bump_ht * Math.pow(e, (-  ((ibos - IBO_of_gain_bump)*(ibos - IBO_of_gain_bump)) / ((gain_bump_width)*(gain_bump_width)) ) );
    
			//Add extra foldover:
			let f:number;
    		if (ibos > 0){
        		f = -(gain_foldover / 20) * (ibos*ibos);
			}else {
				f = 0;
			}
    
    		compression = yp + bump + f
		}else{
			//Compute phase response as a Gaussian curve.
    		let z:number = Math.abs(ibos - IBO_of_phase_peak); 
    		phase_shift = phase_max * Math.pow(e,  (-  Math.pow( (z / phase_width), phase_shape) ) );
		}

		switch (resultRequest){
			case "compr":
    		return compression;
			break;
		case "Pout":
    		return (Pin + ss_gain + compression);
			break;
		case "gain":
    		return (ss_gain + compression);
			break;
		case "phase":
    		return phase_shift;
			break;
		default:
			console.log( "Error in function hpa_model3: invalid parameter requested: " + resultRequest );
			break;
		}
	}



} // End class